import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import StripExhibitionist from './StripExhibitionist';
import ExhibitionistBox, {
  ExhibitionistBoxProps,
  ExhibitionistBoxType,
} from '../_partials/ExhibitionistBox';
import ExhibitionistEmptyState from '../_partials/ExhibitionistEmptyState';

import s from './StripExhibitionist.scss';

class StripExhibitionistBox extends React.Component<
  ExhibitionistBoxProps & WithTranslation
> {
  render() {
    return (
      <ExhibitionistBox
        {...this.props}
        exhibitionistType={ExhibitionistBoxType.STRIP}
        emptyView={
          <ExhibitionistEmptyState
            moduleId={this.props.moduleId}
            view="small"
            className={s['empty-state']}
            exhibitionistType={ExhibitionistBoxType.STRIP}
          />
        }
      >
        {boxProps => <StripExhibitionist {...boxProps} />}
      </ExhibitionistBox>
    );
  }
}

export default withTranslation()(
  StripExhibitionistBox
) as React.ComponentType<{}>;
